module.exports = __webpack_public_path__ + "static/media/bd-insights-hero-1920.77d39427.jpg";